<template>
    <article class="description-box" :class="`description-box--${gridLayout} description-box--${hasShadow}`">
        <h2 class="description-box__title">{{ title }}</h2>
        <p class="description-box__description" v-html="$sanitize(paragraph)"></p>
        <SccLink v-if="link" class="description-box__link" :to="link">
            {{ linkText }}
        </SccLink>
    </article>
</template>

<script>
import './description-box.scss';
import SccLink from '../global/SccLink';

export default {
    name: 'DescriptionBox',
    components: { SccLink },
    __editor: {
        fields: {
            gridLayout: {
                widget: 'select',
                values: ['span-1', 'span-2', 'span-3'],
            },
            hasShadow: {
                widget: 'select',
                values: ['has-shadow', 'no-shadow'],
            },
            title: {
                widget: 'text',
            },
            paragraph: {
                widget: 'textarea',
            },
            linkText: {
                widget: 'text',
            },
            link: {
                widget: 'text',
            },
        },
    },
    props: {
        gridLayout: {
            type: String,
            default: 'span-2',
        },
        hasShadow: {
            type: String,
            default: 'no-shadow',
        },
        title: {
            type: String,
            default: '',
        },
        paragraph: {
            type: String,
            default: 'About paragraph',
        },
        linkText: {
            type: String,
            default: 'About link',
        },
        link: {
            type: String,
            default: '',
        },
    },
};
</script>
